import { AutomationCourse } from '../types';
import { module1 } from './modules/module1';
import { module2 } from './modules/module2';
import { module3 } from './modules/module3';
import { module4 } from './modules/module4';
import { module5 } from './modules/module5';
import { module6 } from './modules/module6';

export const N8N_COURSES: AutomationCourse[] = [
  {
    id: 'n8n-workflow-automation',
    title: 'n8n Workflow Automation',
    description: 'Master open-source workflow automation with n8n. Build powerful integrations, automate business processes, and create custom nodes for any use case.',
    level: 'intermediate',
    duration: '10 hours',
    category: 'workflow-automation',
    image: '/api/placeholder/400/300',
    tags: ['n8n', 'Automation', 'Workflow', 'Integration', 'Open Source', 'Self-hosted', 'ETL', 'iPaaS'],
    prerequisites: [
      'Basic JavaScript knowledge',
      'Understanding of APIs and REST',
      'Familiarity with JSON data structure',
      'Basic command line skills'
    ],
    objectives: [
      'Install and configure n8n for production use',
      'Build complex multi-step automation workflows',
      'Integrate with 500+ APIs and services',
      'Develop custom nodes in JavaScript',
      'Deploy scalable automation solutions',
      'Implement error handling and monitoring'
    ],
    learningOutcomes: [
      'Design and implement automated workflows',
      'Connect multiple services and APIs seamlessly',
      'Handle errors and edge cases gracefully',
      'Deploy n8n to production environments',
      'Create custom integrations and nodes',
      'Optimize workflow performance and costs',
      'Monitor and maintain automation systems'
    ],
    modules: [
      module1,
      module2,
      module3,
      module4,
      module5,
      module6
    ],
    type: 'automation'
  }
];
